import fetch from "@/utils/request";

import i18n from "@/locales/index";

export default {
  postWithdrawOrder(data?: object, config = {}): any {
    return fetch({
      url: "/php/api/withdrawal/submit_order",
      method: "post",
      data,
      loadingText: i18n.t("common.withdraw_text"),
      ...config
    });
  }
};
